import { ENDPOINTS } from '@config/endpoints';
import { HTTP_METHOD } from '@config/net';

import { AccountGetMe } from '@services/account/account-get-me/types';
import { authedJsonFetch } from '@services/base/authed-json-fetch';
import { AccountGetMeResponseDto } from '@services/dto/account';
import { accountGetMeResponseFromDto } from '@mapping/account/account-get-me';

export const accountGetMe: AccountGetMe = (_requestData, authData) => {
  const { promise, cancel } = authedJsonFetch<AccountGetMeResponseDto>(
    ENDPOINTS.account.me(),
    authData,
    {
      method: HTTP_METHOD.GET,
    }
  );

  return {
    promise: promise.then(accountGetMeResponseFromDto),
    cancel,
  };
};
